import Box from '@mui/material/Box'
import ImageList from '@mui/material/ImageList'
import ImageListItem from '@mui/material/ImageListItem'
import NextImage from 'next/image'

interface ImageItem {
    src: string
    alt?: string
    srcSet?: string
    sizes?: string
}

interface MasonryImageListProps {
    images?: ImageItem[]
}

export default function MasonryImageList({ images = [] }: MasonryImageListProps) {
    return (
        <Box sx={{ width: '100%', height: { xs: 'auto', md: '80vh' }, overflowY: 'scroll' }}>
            <ImageList variant='masonry' cols={3} gap={8}>
                {images.map((item) => (
                    <ImageListItem key={item.src} sx={{ position: 'relative' }}>
                        <Box
                            sx={{
                                position: 'relative',
                                width: '100%',
                                paddingBottom: '75%',
                                borderRadius: '15px',
                                overflow: 'hidden',
                            }}
                        >
                                <NextImage
                                    src={item.src}
                                    alt={item.alt || ''}
                                    fill
                                    sizes='(max-width: 600px) 100vw, 33vw'
                                    style={{ objectFit: 'cover' }}
                                    loading='lazy'
                                />
                        </Box>
                    </ImageListItem>
                ))}
            </ImageList>
        </Box>
    )
}


